import React from "react";
import { Box, Link, makeStyles } from "@material-ui/core";
import colors from "Styles/colors";
import { usePartnerConfig } from "Hooks/usePartnerConfig";

const LinkToOrbit = () => {
  const { enabledFeatures } = usePartnerConfig();
  const classes = useStyles();

  if (enabledFeatures.indexOf("orbit_providers") === -1) {
    return null;
  }

  return (
    <Box ml={2}>
      <Link className={classes.link} href={process.env.REACT_APP_ORBIT_URL}>
        Go to new Partner Portal
      </Link>
    </Box>
  );
};

const useStyles = makeStyles({
  link: {
    color: colors.white,
    textDecoration: "underline",
    fontSize: 12,
    "&:hover": {
      color: colors.white,
    },
  },
});

export default LinkToOrbit;
